/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import axios from 'axios'
import { Alert, Button } from '@mui/material';
import FadeIn from 'react-fade-in/lib/FadeIn';
import fontColor from '../../lib/fontColor';
import { getStyle, setStyle, setLogo, getBizID, setBackground } from '../../libs/todoSlice'
import { useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getLandingPageWordRedux, setLandingPageWordRedux, getFeedbackRedux, setFeedbackRedux } from '../../libs/themeSlice';
import { str2rgb } from 'string-color-converter';
import Swal from 'sweetalert2';
import { Radio } from 'antd';
import styled from 'styled-components';

function Theme_Color() {
  const dispatch = useDispatch()
  // const logo = useSelector(getLogo)
  const style = useSelector(getStyle)
  const business_id = useSelector(getBizID)
  const [styleDefault, setStyleDefault] = useState([])
  const [primaryPicker, setPrimaryPicker] = useState()
  const [secondaryPicker, setSecondaryPicker] = useState()
  // const [ landingPageWord, setLandingPageWord ] = useState('')
  // const [ feedback, setFeedback ] = useState({
  //   message: '',
  //   color: ''
  // })
  useEffect(() => {
    setStyleDefault(style)
    setPrimaryPicker(str2rgb(style.primary_color))
    setSecondaryPicker(str2rgb(style.secondary_color))

  }, [])

  const landingPageWord = useSelector(getLandingPageWordRedux)
  const setLandingPageWord = (action) => {
    dispatch(setLandingPageWordRedux({
      landingPageWord: action
    }))
  }

  const feedback = useSelector(getFeedbackRedux)
  const setFeedback = (action) => {
    dispatch(setFeedbackRedux({
      feedback: action
    }))
  }

  const updateTheme = async () => {


    setFeedback('')
    let formData = new FormData();
    formData.append('biz_id', business_id)
    formData.append('primary_color', `rgba(${primaryPicker.r},${primaryPicker.g},${primaryPicker.b},${primaryPicker.a})`)
    formData.append('secondary_color', `rgba(${secondaryPicker.r},${secondaryPicker.g},${secondaryPicker.b},${secondaryPicker.a})`)
    formData.append('image_logo', color.logo)
    formData.append('image_background', color.background)
    formData.append('logo_style', logoStyle)
    formData.append('landing_page_wording', landingPageWord)

    await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/themes`,
      data: formData,
    }).then(({ data, status }) => {
      setFeedback({
        message: 'Create Success',
        color: 'success'
      })
    }, ({ response }) => {
      setFeedback({
        message: 'Create Fail',
        color: 'error'
      })
    })
    window.location.reload()
  }

  const [color, setColor] = useState({
    displayColorPicker: false,
    color: {
      r: '248',
      g: '249',
      b: '250',
      a: '1',
    },
    displayColorPickerSecondary: false,
    colorSecondary: {
      r: '241',
      g: '112',
      b: '19',
      a: '1',
    },
    logo: null,
    background: null,
    style: { landing_page_wording: null }
  });

  const params = useParams()
  useEffect(() => {
    setLandingPageWord(style.landing_page_wording)
    if (style.primary_color) {
      const primary = style.primary_color.replaceAll("rgba(", "").replaceAll(")", "").split(',')
      const secondary = style.secondary_color.replaceAll("rgba(", "").replaceAll(")", "").split(',')
      setColor({
        ...style, color: {
          r: parseInt(primary[0]),
          g: parseInt(primary[1]),
          b: parseInt(primary[2]),
          a: parseInt(primary[3]),
        },
        colorSecondary: {
          r: parseInt(secondary[0]),
          g: parseInt(secondary[1]),
          b: parseInt(secondary[2]),
          a: parseInt(secondary[3]),
        }
      })
    }
  }, [])

  const handleClick = () => {
    setColor({ ...color, displayColorPicker: !color.displayColorPicker })
  }

  const handleClose = () => {
    setColor({ ...color, displayColorPicker: false })
  };

  const handleChange = (e) => {
    setPrimaryPicker(e.rgb)
    // setColor({ ...color, color: e.rgb })
    // dispatch(setStyle({
    //   style: {

    //     primary_color: `rgba(${e.rgb.r}, ${e.rgb.g}, ${e.rgb.b}, ${e.rgb.a})`,
    //     secondary_color: style.secondary_color,
    //     // landing_page_wording:style.landing_page_wording
    //   }
    // }))
  };

  const handleClickSecondary = () => {
    setColor({ ...color, displayColorPickerSecondary: !color.displayColorPickerSecondary })
  }

  const handleCloseSecondary = () => {
    setColor({ ...color, displayColorPickerSecondary: false })
  };

  const handleChangeSecondary = (e) => {
    setSecondaryPicker(e.rgb)
    // setColor({ ...color, colorSecondary: e.rgb })
    // dispatch(setStyle({
    //   style: {
    //     primary_color: style.primary_color,
    //     secondary_color: `rgba(${e.rgb.r}, ${e.rgb.g}, ${e.rgb.b}, ${e.rgb.a})`,
    //     // landing_page_wording:style.landing_page_wording
    //   }
    // }))
  };

  const [logoStyle, setLogoStyle] = useState(1)
  const handleLogoStyleChange = (e) => {
    setLogoStyle(Number(e.target.value));
  };
  const handleChangeImage = async (e) => {
    setColor({ ...color, logo: e.target.files[0] })

    if (e.target.files[0]) {
      const maxSize = 2 * 1024 * 1024
      if (e.target.files[0].size > maxSize) {
        setColor({ ...color, logo: "" })
        e.target.value = "";
        Swal.fire({
          icon: 'error',
          title: 'ไฟล์รูปมีขนาดใหญ่เกินไป',
          footer: 'ไฟล์ต้องมีขนาดไม่เกิน 2 MB'
        })
      } else {
        function toBase64() {
          return new Promise((resolve, reject) => {
            // const imgURL = URL.createObjectURL(color.logo)
            const imgTobase64 = new FileReader()
            imgTobase64.readAsDataURL(e.target.files[0]);
            imgTobase64.onload = () => resolve(imgTobase64.result);
            imgTobase64.onerror = error => reject(error);
          })
        }
        const base64 = await toBase64()
        let reBase61 = base64.replaceAll('data:image/png;base64,', "")
        dispatch(setLogo({ logo: reBase61, style: logoStyle }))
      }
    }
  }

  const handleChangeBackground = async (e) => {
    setColor({ ...color, background: e.target.files[0] })

    if (e.target.files[0]) {
      const maxSize = 2 * 1024 * 1024
      if (e.target.files[0].size > maxSize) {
        setColor({ ...color, background: "" })
        e.target.value = "";
        Swal.fire({
          icon: 'error',
          title: 'ไฟล์รูปมีขนาดใหญ่เกินไป',
          footer: 'ไฟล์ต้องมีขนาดไม่เกิน 2 MB'
        })
      } else {
        function toBase64() {
          return new Promise((resolve, reject) => {
            // const imgURL = URL.createObjectURL(color.logo)
            const imgTobase64 = new FileReader()
            imgTobase64.readAsDataURL(e.target.files[0]);
            imgTobase64.onload = () => resolve(imgTobase64.result);
            imgTobase64.onerror = error => reject(error);
          })
        }
        const base64 = await toBase64()
        let reBase61 = base64.replaceAll('data:image/png;base64,', "")
        dispatch(setBackground({ background: reBase61 }))
      }
    }
  }


  useEffect(() => {
    document.body.classList.add('dialog-theme');
    return () => {
      document.body.classList.remove('dialog-theme');
    }
  })

  const styles = reactCSS({
    'default': {
      color: {
        width: '100px',
        height: '25px',
        borderRadius: '2px',
        background: primaryPicker ? `rgba(${primaryPicker.r}, ${primaryPicker.g}, ${primaryPicker.b}, ${primaryPicker.a})` : 'black',
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
        width: '112px'
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  });

  const stylesSecondary = reactCSS({
    'default': {
      color: {
        width: '100px',
        height: '25px',
        borderRadius: '2px',
        background: secondaryPicker ? `rgba(${secondaryPicker.r}, ${secondaryPicker.g}, ${secondaryPicker.b}, ${secondaryPicker.a})` : 'black',
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
        width: '112px',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  });


  // useEffect(() => {
  //   console.log(style,'style')
  // },[style])

  const clear = async (colors) => {
    // console.log('colors.landing_page_wording :>> ', colors.landing_page_wording);
    // console.log('style.landing_page_wording :>> ', style.landing_page_wording);

    // const landingpagewording = colors.landing_page_wording
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
    }).then(({ data, status }) => {
      // dispatch(setStyle({style:{landing_page_wording:style.landing_page_wording}}))
      // console.log('data.data.themes.style.primary_color :>> ', typeof data.data.themes.style.primary_color);
      if (data.data.themes.style.primary_color) {
        setPrimaryPicker(str2rgb(data.data.themes.style.primary_color))
        setSecondaryPicker(str2rgb(data.data.themes.style.secondary_color))
        // console.log('data.data.themes.style.primary_color :>> ', data.data.themes.style.primary_color);

        const primary = data.data.themes.style.primary_color.replaceAll("rgba(", "").replaceAll(")", "").split(',')
        const secondary = data.data.themes.style.secondary_color.replaceAll("rgba(", "").replaceAll(")", "").split(',')


        setColor({
          ...data.data.themes.style, color: {
            r: parseInt(primary[0]),
            g: parseInt(primary[1]),
            b: parseInt(primary[2]),
            a: parseInt(primary[3]),
          },
          colorSecondary: {
            r: parseInt(secondary[0]),
            g: parseInt(secondary[1]),
            b: parseInt(secondary[2]),
            a: parseInt(secondary[3]),
          }
        })
        dispatch(setStyle({
          style: {
            ...style,
            primary_color: `rgba(${parseInt(primary[0])},${parseInt(primary[1])},${parseInt(primary[2])},${parseInt(primary[3])})`,
            secondary_color: `rgba(${parseInt(secondary[0])},${parseInt(secondary[1])},${parseInt(secondary[2])},${parseInt(secondary[3])})`,
            landing_page_wording: data.data.themes.style.landing_page_wording
          }
        }
        ))
        setLandingPageWord(data.data.themes.style.landing_page_wording)
        // console.log('landingpagewording :>> ', landingpagewording);
        // console.log('data :>> ', data.data.themes.style.landing_page_wording);
        // console.log('landing_page_wording :>> ', colors.landing_page_wording);
      }
    }, ({ response }) => {

    })
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${business_id}`,
    }).then(({ data, status }) => {
      dispatch(setLogo({ logo: `${data.data}` }))
    }, ({ response }) => {

    })
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/background?business_id=${business_id}`,
    }).then(({ data, status }) => {
      dispatch(setBackground({ background: `${data.data}` }))
    }, ({ response }) => {

    })




  };

  return (
    <div style={{ width: '467px' }}>
      <div className="col-12 text-center" style={{ paddingBottom: '30px' }}>
        <span
          style={{
            fontSize: '34px',
          }}
        >
          <b>ออกแบบสีระบบ</b>
        </span>
      </div>
      <div style={{ display: 'flex', placeContent: 'center' }}>
        <table>
          <tbody>
            <tr>
              <td style={{ width: '150px', height: '50px' }}><b>Logo</b></td>
              <td style={{ height: '50px' }}>
                <div style={{ textAlign: 'center' }}>
                  <input type="file" id="img" name="img" accept="image/*" className="w-100" onChange={handleChangeImage} />
                  {color.logo &&
                    <img
                      key={logoStyle}
                      src={URL.createObjectURL(color.logo)}
                      alt="img"
                      style={{
                        width: logoStyle === 1 ? '80px' : '120px', height: '80px', margin: '10px 0 10px', display: 'flex'
                      }} />
                  }
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '150px', height: '50px' }}><b>Logo Style</b></td>
              <td style={{ height: '50px' }}>
                <div>
                  <Radio.Group name="radiogroup" style={{ color: fontColor(style.secondary_color) }} value={logoStyle} onChange={handleLogoStyleChange}>
                    <Radio value={1}>แนวตั้ง</Radio>
                    <Radio value={2}>แนวนอน</Radio>
                  </Radio.Group>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '150px', height: '50px' }}><b>Background</b></td>
              <td style={{ height: '50px' }}>
                <div style={{ textAlign: 'center' }}>
                  <input type="file" id="img" name="img" accept="image/*" className="w-100" onChange={handleChangeBackground} />
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '150px', height: '50px' }}><b>Primary Color</b></td>
              <td style={{ height: '50px' }}>
                <div style={styles.swatch} onClick={handleClick}>
                  <div style={styles.color} />
                </div>
                {
                  color.displayColorPicker ?
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker color={primaryPicker} onChange={handleChange} />
                    </div> : null
                }
              </td>
            </tr>
            <tr>
              <td style={{ width: '150px', height: '50px' }}><b>Secondary Color</b></td>
              <td style={{ height: '50px' }}>
                <div style={stylesSecondary.swatch} onClick={handleClickSecondary}>
                  <div style={stylesSecondary.color} />
                </div>
                {
                  color.displayColorPickerSecondary ?
                    <div style={stylesSecondary.popover}>
                      <div style={stylesSecondary.cover} onClick={handleCloseSecondary} />
                      <SketchPicker color={secondaryPicker} onChange={handleChangeSecondary} />
                    </div> : null
                }
              </td>
            </tr>
            <tr>
              <td><div className="col-12 my-2 text-center">
                <b>Landing Page Word</b>
              </div>
              </td>
              <td>
                <div className="col-12" style={{ marginBottom: 5, marginTop: 15 }}>
                  <ReactQuill
                    style={{
                      height: 'auto', width: 300
                    }}
                    value={landingPageWord}
                    onChange={(e) => {
                      setLandingPageWord(e)
                    }}

                  />
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '150px', height: '50px' }}>
                {color.background &&
                  <b>Preview Background</b>
                }
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                  {color.background &&
                    <img
                    key={logoStyle}
                    src='/one-platform.png'
                    alt="img"
                    style={{
                      maxWidth: logoStyle === 1 ? '15px' : '30px', maxHeight: '15px', margin: '10px 0 10px', display: 'flex'
                    }} />
                  }
                  {color.background &&
                    <span style={{ fontSize: '8px' }}>&nbsp;business name</span>
                  }
                </div>
                {color.background &&
                  <span style={{ fontSize: '2px' }}>{landingPageWord}</span>
                }
              </td>
              <td style={{ height: '50px' }}>
                <div style={{ textAlign: 'center' }}>
                  {color.background &&
                    <img
                      src={URL.createObjectURL(color.background)}
                      alt="img"
                      style={{
                        width: '135px', height: '110px', position: 'relative', zIndex: '1', top: '190px', left: '68px'
                      }} />
                  }
                  <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: '100%' }}>
                    {color.background &&
                      <img
                        src="/img_login_RA_vector.png"
                        style={{
                          maxWidth: '200px', maxHeight: '200px', margin: '90px 0 15px', position: 'relative', zIndex: '0'
                        }}
                        alt=''
                      />
                    }
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: '30px', justifyContent: 'center', display: 'flex' }}>
        <Button
          variant="outlined"
          style={{ borderColor: style.secondary_color, borderRadius: '6px', width: '200px', height: '36px', marginRight: '50px' }}
          onChange={handleChange}
          onClick={() => { clear(styleDefault) }}
        >
          <span style={{ color: '#000000' }}>Clear</span>
        </Button>
        <Button
          variant="contained"
          style={{ background: style.secondary_color, borderRadius: '6px', width: '200px', height: '36px', }}
          onClick={() => { updateTheme() }}
        >
          <span style={{ color: fontColor(style.secondary_color) }}>Save</span>
        </Button>
      </div>
      {feedback.message &&
        <FadeIn>
          <div style={{ marginTop: '20px', textAlign: '-webkit-center' }}>
            <Alert variant="filled" severity={feedback.color} style={{ width: '450px' }}>
              {feedback.message}
            </Alert>
          </div>
        </FadeIn>
      }
    </div>
  )
}

export default Theme_Color